import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { needsMetaToken } from "../types/user";

const AuthProtected = (props: any) => {
  const { user, loading } = useAuth();
  const routerLocation = useLocation();

  // ⏳ Aguarda bootstrap, não decide nada
  if (loading) {
    return null; // ou <Loader />
  }

  // 🚫 Não autenticado → login
  if (!user) {
    return (
      <Navigate
        to="/auth-login"
        replace
        state={{ from: routerLocation }}
      />
    );
  }

  // 🚨 DESVIO META
  if (needsMetaToken(user)) {
    return <Navigate to="/auth-facebook" replace />;
  }

  // autenticado → libera
  return <>{props.children}</>;
};

export { AuthProtected };
